export default __webpack_public_path__ + "static/media/Triceratopodo.1165afff.png";